import React, { useEffect, useState } from 'react';
import { getUsers } from '../../services/users/usersService';
import { inputClass } from './contractLabels';

// Vendedores y admins activos (un admin también puede conseguir el negocio; él ya ve todo)
const loadSellers = async () => {
    const [sellers, admins] = await Promise.all([
        getUsers(1, 200, { role: 'ROLE_SELLER', active: true }),
        getUsers(1, 200, { role: 'ROLE_ADMIN', active: true }),
    ]);
    const option = (u, isAdmin) => ({
        email: u.email,
        label: `${[u.firstName, u.lastName].filter(Boolean).join(' ') || u.email} · ${u.email}${isAdmin ? ' (admin)' : ''}`,
    });
    return [
        ...(sellers.content || []).map((u) => option(u, false)),
        ...(admins.content || []).map((u) => option(u, true)),
    ];
};

// Lista para elegir el vendedor de un contrato; value '' = sin vendedor
const SellerSelect = ({ id, value, onChange }) => {
    const [options, setOptions] = useState([]);
    const [loadError, setLoadError] = useState(false);

    useEffect(() => {
        loadSellers().then(setOptions).catch((e) => {
            console.error('Error al cargar los vendedores: ', e);
            setLoadError(true);
        });
    }, []);

    // El vendedor actual puede no estar en la lista (ej. usuario desactivado): se muestra igual
    const current = value && !options.some((o) => o.email === value) ? [{ email: value, label: value }] : [];

    return (
        <>
            <select id={id} className={inputClass} value={value || ''} onChange={(e) => onChange(e.target.value)}>
                <option value="">Sin vendedor</option>
                {[...current, ...options].map((o) => <option key={o.email} value={o.email}>{o.label}</option>)}
            </select>
            {loadError && <p className="text-xs text-red-600 mt-1">No se pudo cargar la lista de vendedores.</p>}
        </>
    );
};

export default SellerSelect;
